/**
 * @generated SignedSource<<e462bfa12a97fc6d43f5217ee6d55087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRequestHold_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly hasRequestedHoldForBuyer?: boolean | null;
  readonly displayInfo?: {
    readonly ctas: {
      readonly showHoldRequest: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpSharedRequestHold_item";
};
export type PdpSharedRequestHold_item$key = {
  readonly " $data"?: PdpSharedRequestHold_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRequestHold_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRequestHold_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "hasRequestedHoldForBuyer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "kind": "LinkedField",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showHoldRequest",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "2b8ad84dc0c70010033f22c0ceb4fe08";

export default node;
